import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import * as moment from 'moment-timezone';

@Pipe({
    name: 'convertDateSubmitted',
    standalone: false
})
export class ConvertDateSubmittedPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {
  }

  transform(txt) {
    if (txt === undefined)
      return 'Never';
    txt = txt.split(' ');
    return txt[0];
  }

}
